//判断Android or IOS
function isMobileDevice () {
    var ua = navigator.userAgent;
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/);
    return isIphone || isAndroid;
}

//判断用户移动设备
function is_mobile () {
    var reg = /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i;
    return reg.test(navigator.userAgent.toLowerCase());
}

//判断是否是微信端
function isWeiXin () {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
}

//uuid随机字符串加数字命名
function uuid () {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid;
}

//过滤特殊符号及空格
function Trim (str) {
    return str.replace(/(^\s*)|(\s*$)/g, '')
}

//分割字符串
function SplitStr (str, mark) {
    var s, ss;
    var s = str;
    // 在每个空格字符处进行分解。
    ss = s.split(mark);
    return ss;
}

//取随机数
function RDF (min, max) {
    return Math.random() * (max - min) + min;
};

function CanvasScaleToWindow (el) {
    let WH = window.innerHeight
    if (is_mobile()) {
        // if (WH > 1480) {
        // 	el.style.cssText = `transform:scale(${WH/1480});transform-origin:center top;`
        // }else{
        // 	el.style.transform = `translateY(-${(1480-WH)/2}px)`
        // }
    } else {
        document.getElementById('app').style.height = '1480px'
        el.style.cssText = `transform:scale(${WH / 1480});transform-origin:center top;display:block;margin:0 auto;height:1480px`
    }
}
export { is_mobile, RDF, SplitStr, Trim, uuid, isWeiXin, isMobileDevice, CanvasScaleToWindow }


// WEBPACK FOOTER //
// ./src/Toolset.js